export const clsPrefix = 'cn-statistic-card-pro';
